import { HostedCampaign } from '@givz/core-client';
import { useNotificationChannel } from '@hooks/notification';
import { IconButton, Tooltip } from '@mui/material';
import { routes } from '@routes';
import { useNavigate } from 'react-router-dom';
import ContentCopySharpIcon from '@mui/icons-material/ContentCopySharp';
import { FunctionComponent } from 'react';
import { useDuplicateIncentiveDialog } from '.';

export type DuplicateIncentiveButtonProps = {
  gid: string;
  name?: string;
};

export const DuplicateIncentiveButton: FunctionComponent<
  DuplicateIncentiveButtonProps
> = (props) => {
  const { gid, name } = props;
  const navigate = useNavigate();
  const { success } = useNotificationChannel();
  const { showDialog } = useDuplicateIncentiveDialog({
    onDone: onDuplicated,
  });

  function onDuplicated(data: HostedCampaign) {
    success(`The incentive ${data?.gid} was created.`);
    navigate(routes.editIncentive(data.gid));
  }

  return (
    <Tooltip title="Duplicate Incentive">
      <IconButton
        size="small"
        onClick={() =>
          showDialog({
            gid,
            name: `Copy ${name}`,
          })
        }
      >
        <ContentCopySharpIcon />
      </IconButton>
    </Tooltip>
  );
};
